import type { IRoleRepository } from '@src/domain/rbac/repository/role_repository';
import type { Role } from '@src/domain/rbac/entities/role.entity';
import type { CreateRoleData } from '@src/domain/rbac/value_objects/create_role_data';

/**
 * Create Role Use Case
 * Creates a new role in the system
 */
export class CreateRoleUseCase {
    constructor(private readonly roleRepository: IRoleRepository) { }

    async execute(data: CreateRoleData): Promise<Role> {
        return await this.roleRepository.create(data);
    }
}
